/**Dependencies */
import React from "react";
import useForm from "../hooks/useForm";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import Swal from "sweetalert2";

/**Styles */
import "../styles/cruceros.scss";

/**Images */
import logoCruiseLine1 from "../images/icons/Logo Royal Caribbean.png";
import logoCruiseLine2 from "../images/icons/Logo Norwegian.png";
import logoCruiseLine3 from "../images/icons/Logo Princess.png";
import formCruceros from "../images/banners/form cruceros.png";

import cruises1 from "../images/royal caribbean.png";
import cruises2 from "../images/norwegian.png";
import cruises3 from "../images/princess cruises.png";
import cruises4 from "../images/disney cruise line.png";

// Services
import { getEmailText } from "../services/emailService";

export const Cruceros = () => {
  const logos = [logoCruiseLine1, logoCruiseLine2, logoCruiseLine3];
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    age: "",
    phone: "",
    message: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre completo: ${formData.fullName} \nEmail: ${formData.email} \nNúmero de teléfono: ${formData.phone} \nMensaje: ${formData.message}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };

  const cardsData = [
    {
      image: cruises1,
      title: "ROYAL CARIBBEAN",
      subtitle: "Caribe y Mediterráneo",
      description:
        "La aventura está de vuelta para siempre, con una linea completa de barcos galardonados que navegan aventuras inolvidables con varios destinos. Simplemente elige un destino y deja que te lleve a tu próxima vacación épica.",
    },
    {
      image: cruises2,
      title: "NORWEGIAN",
      subtitle: "Mediterráneo",
      description:
        "Barcos galardonados, diseñados para que disfrutes como quieras mientras navegas por los destinos más bellos del mundo. Sin importar el destino de tus soñadas vacaciones, siéntete libre de viajar como te guste.",
    },
    {
      image: cruises3,
      title: "Princess Cruises",
      subtitle: "Alaska",
      description:
        "Cada barco Princess es un destino en sí mismo con una amplia gama de comodidades, experiencias culinarias elevadas y actividades encantadoras. Descubre como la experiencia Princess es única.",
    },
    {
      image: cruises4,
      title: "DISNEY CRUISE LINE",
      subtitle: "",
      description:
        "Embárcate en una galardonada experiencia de vacaciones como ninguna otra, en la que nuestros esfuerzos por hacer que tu crucero sea aún más mágico. Crea las mejores vacaciones al estilo Disney combinado la magia de Disney Cruise Line con el encanto de Walt Disney World Resort.",
    },
  ];

  return (
    <div className="cruceros">
      <PrincipalBanner idElemento={7} />
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="section-title outline">Cruceros</h1>
        </div>
      </Container>

      <div className="container-title">
        <h1 className="text-white text-center">
          ¡Descubre el mundo en un crucero!
        </h1>
      </div>

      <div className="container carousel-container py-5">
        <Swiper
          spaceBetween={8}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3000 }}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {logos.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Imagen ${index + 1}`}
                style={{ width: "70%", height: "65px" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <Container>
        {cardsData.map((card, index) => (
          <Row
            className="cards-cruceirs mb-4 g-0 align-items-center"
            key={index}
          >
            {index % 2 === 0 ? (
              <>
                <Col md={6}>
                  <Card.Img
                    src={card.image}
                    alt={card.title}
                    className="w-100"
                    style={{ height: "435px", objectFit: "cover" }}
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "435px",
                    background: "linear-gradient(to bottom, #6e9edc, #8cb9da)",
                  }}
                >
                  <Card.Body className="text-center text-white">
                    <Card.Title className="cards-cruceirs__title mb-2">
                      {card.title}
                    </Card.Title>
                    <Card.Subtitle className="cards-cruceirs__subtitle mb-2">
                      {card.subtitle}
                    </Card.Subtitle>
                    <div>
                      <div>
                        <Card.Text
                          className="cards-cruceirs__description"
                          style={{ textAlign: "justify" }}
                        >
                          {card.description}
                        </Card.Text>
                      </div>
                    </div>
                  </Card.Body>
                </Col>
              </>
            ) : (
              <>
                <Col
                  md={6}
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "435px",
                    background: "linear-gradient(to bottom, #6e9edc, #8cb9da)",
                  }}
                >
                  <Card.Body className="text-center text-white">
                    <Card.Title className="cards-cruceirs__title mb-2">
                      {card.title}
                    </Card.Title>
                    <Card.Subtitle className="cards-cruceirs__subtitle mb-2">
                      {card.subtitle}
                    </Card.Subtitle>
                    <div>
                      <Card.Text
                        className="cards-cruceirs__description"
                        style={{ textAlign: "justify" }}
                      >
                        {card.description}
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Col>
                {/* Imagen a la derecha */}
                <Col md={6}>
                  <Card.Img
                    src={card.image}
                    alt={card.title}
                    className="w-100"
                    style={{ height: "435px", objectFit: "cover" }}
                  />
                </Col>
              </>
            )}
          </Row>
        ))}
      </Container>

      <div
        className="py-5 container"
        style={{ position: "relative", height: "600px" }}
      >
        <img
          src={formCruceros}
          alt="Imagen cruceros"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "15px",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "8%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            padding: "30px",
            borderRadius: "10px",
            width: "80%",
            maxWidth: "600px",
            textAlign: "start",
            color: "white",
          }}
        >
          <h2 style={{ fontSize: "30px" }}>Conoce los resorts.</h2>
          <br />
          <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
            <Row className="g-4">
              <Col xs={12} md={12}>
                <Form.Group controlId="formNombre">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    onChange={handleChange}
                    value={formData.fullName}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formCorreo">
                  <Form.Label>Correo Electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={formData.email}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="formTelefono">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    maxLength={10}
                    onChange={handleChange}
                    value={formData.phone}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formDuracion">
                  <Form.Label>Mensaje</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    onChange={handleChange}
                    className="input-light text-white"
                    value={formData.message}
                    required
                  />
                </Form.Group>
                <div className="d-flex justify-content-center">
                  <Button
                    className="btn-white"
                    type="submit"
                    style={{
                      width: "20%",
                      height: "35px",
                      marginTop: "25px",
                      fontSize: "14px",
                    }}
                  >
                    Cotiza
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};
